
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[event]/artikel/[slug]",
      function () {
        return require("private-next-pages/[event]/artikel/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[event]/artikel/[slug]"])
      });
    }
  